import union from 'lodash.union';

// Utils
// @ts-ignore
import createDeepEqualSelector from 'utils/reselect/createDeepEqualSelector';

// Selectors
import { selectTimesheetEntriesApiErrorUuids } from 'services/timesheetTimesheetEntriesAPIErrors/selectors';
// @ts-ignore
import { selectErrorsTimesheetEntryUuids } from 'services/timesheetTimesheetEntriesForm/selectors';

const selectErrorUuids = createDeepEqualSelector(
    [selectTimesheetEntriesApiErrorUuids, selectErrorsTimesheetEntryUuids],
    (
        timesheetEntriesApiErrorUuidsState?: string[],
        errorsTimesheetEntryUuidsState?: string[]
    ) =>
        union(
            timesheetEntriesApiErrorUuidsState,
            errorsTimesheetEntryUuidsState
        )
);

export { selectErrorUuids };
